import type { ReactNode } from 'react';

import { cn } from '@/services/utils/classnames';

type AuthFormSlotProps = {
  children: ReactNode;
  className?: string;
};

export const AuthFormSlot = ({ children, className }: AuthFormSlotProps) => {
  return (
    <div
      className={cn(
        'absolute bottom-[-24px] left-1/2 z-authCard w-full max-w-[520px] -translate-x-1/2 px-4 dp-md:bottom-[-72px] dp-md:left-auto dp-md:right-[96px] dp-md:w-auto dp-md:max-w-none dp-md:translate-x-0 dp-md:px-0 dp-lg:right-[144px]',
        className
      )}
    >
      {children}
    </div>
  );
};
